module.exports = __webpack_public_path__ + "static/media/1POLICY49.868fb8d4.jpg";